module.exports = __webpack_public_path__ + "img/00-menu-bar-on_04.e865aa23.png";